import * as angular from "angular";
import * as moment from "moment-timezone";

angular
  .module('bringoz.admin.commons')
  .filter('bringozDay', bringozDay);

function bringozDay( moment) {
  return function bringozDayFilter(object: any, ref: string, format: 'long' | 'short' = 'long', timeZoneId?: string) {
    if (object && object[ref]) {
      return formatDay(object[ref], format, timeZoneId);
    } else {
      return '---';
    }
  }

  function formatDay(date: any, format: 'long' | 'short', timeZoneId?: string): string {
    let momentDate;

    if (timeZoneId) {
      momentDate = moment(date).tz(timeZoneId);
    } else {
      momentDate = moment(date);
    }

    return format === 'long' ? momentDate.format('dddd') : momentDate.format('ddd');
  }
}
